/**
 * Distances and durations as a passenger reads them.
 *
 * The API speaks metres and seconds everywhere, which is the right thing for a
 * contract and the wrong thing for a label: "4327 m" and "923 s" are a journey
 * nobody can picture. These do the one conversion, in one place, so the map
 * pill and any screen that shows the same journey cannot disagree about it.
 *
 * Metric, because the service prices rides in naira and operates in Nigeria.
 */

/** Metres as "850 m", "4.3 km" or "27 km". */
export function formatDistance(metres: number): string {
    if (!Number.isFinite(metres) || metres < 0) return "";
    if (metres < 1000) return `${Math.round(metres)} m`;

    const km = metres / 1000;
    // One decimal up to 10km, where it is the difference between two streets,
    // and none above it, where it is noise.
    return km < 10 ? `${km.toFixed(1)} km` : `${Math.round(km)} km`;
}

/** Seconds as "1 min", "18 min", "2 hr" or "2 hr 15 min". */
export function formatDuration(seconds: number): string {
    if (!Number.isFinite(seconds) || seconds < 0) return "";

    // Never "0 min": a journey that exists takes at least a minute to a reader,
    // and a zero reads as a failed calculation.
    const minutes = Math.max(1, Math.round(seconds / 60));
    if (minutes < 60) return `${minutes} min`;

    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest === 0 ? `${hours} hr` : `${hours} hr ${rest} min`;
}
